(function() { module.exports = window["Bernie_l10nBundle_tr_TR"]; }());